module.exports = __webpack_public_path__ + "static/media/resume.ebd71f6b.pdf";